// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"757": "27fa96ed57a3f40a","82": "9ad78369b68d7ddd",}[chunkId] + ".css"
}